import type { CatalogItem } from "./catalogItemTypes";
import type { CatalogItemType } from "./doc/catalogTypes";
import { catalogItemTypeMap } from "./doc/catalogTypes";

export function isCatalogItemType(type: string): type is CatalogItemType {
  return type in catalogItemTypeMap;
}

export function assertIsCatalogItemOfType<T extends CatalogItemType>(
  item: CatalogItem,
  type: T,
): asserts item is CatalogItem & { catalogItemType: T } {
  if (item.catalogItemType !== type) {
    throw new Error(`Expected catalog item of type ${type}, but got ${item.catalogItemType}`);
  }
}
